import { ColorModeProvider } from './theme';
import React, { useState } from 'react';
import { Routes, Route } from 'react-router-dom';
import Topbar from './scenes/global/Topbar';
import Sidebar from './scenes/global/Sidebar';
import Footer from './scenes/global/Footer';
import Dashboard from './scenes/dashboard';
import AddBrokerModal from './features/AddBrokerModal';
import SelectSensorModal from './features/SelectSensorModal';
import FAQ from './scenes/faq';
import { LocalStorageProvider } from './services/localStorageContext';
import { Box } from '@mui/material';
import { ConnectionProvider } from './services/connectionContext/connectionContext';

function App() {
  const [sidebarVisible, setSidebarVisible] = useState(true);

  return (
    <LocalStorageProvider>
      <ConnectionProvider>
        <ColorModeProvider>
          <Box className="app" sx={{ display: 'flex', height: '100vh' }}>
            {/* Sidebar */}
            {/* <Sidebar sidebarVisible={sidebarVisible} /> */}

            {/* Main Content Area */}
            <Box
              component="main"
              className="content"
              sx={{
                display: 'flex',
                flexDirection: 'column',
                flexGrow: 1,
                overflow: 'hidden', // Prevent overflow issues
              }}
            >
              {/* Topbar */}
              <Topbar setSidebarVisible={setSidebarVisible} />

              {/* Main Content */}
              <Box
                sx={{
                  flexGrow: 1,
                  overflow: 'auto', // Enable scrolling when content overflows
                }}
              >
                <Routes>
                  <Route path="/" element={<Dashboard />} />
                  <Route path="/brokers" element={<AddBrokerModal />} />
                  <Route path="/sensors" element={<SelectSensorModal />} />
                  <Route path="/logoSpinning" element={<FAQ />} />
                </Routes>

                {/* Footer */}
                {/* Der Footer kann auch am unteren Rand der Seite befestigt werden, dafür muss dieser aus dieser Box in die übergeordnete Box kopiert werden
                    sprich <Footer /> kann in die Main Content Area verfrachtet werden!*/}
                <Footer />

              </Box>

            </Box>
          </Box>
        </ColorModeProvider>
      </ConnectionProvider>
    </LocalStorageProvider>
  );
}

export default App;

//TODO: eine useMqttTopic- und eine useWebSocketChannel-Hook implementieren, die genau das Subscription-/Unsubscription-Handling abbilden. Das spart Code in den einzelnen UI-Komponenten und erhöht die Wiederverwendbarkeit.

//TODO: "Connect to Sensor" sollte nur auf dem Dashboard zu sehen sein! In dem Modal sollte die Funktionalität zur verfügung stehen, einen nicht aufgelisteten Broker hinzuzufügen!
//TODO: "Add Broker" sollte in der Brokeransicht zur Verfügung stehen!

//TODO: Dashboard -React-Drag and Drop beautiful DND bzw. -Draggable Dnd Kit für die Kacheln der Sensoren/bzw. derer Areas